"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferPreferredLanguage = exports.switchLang = exports.setLangCookie = exports.localizeRoute = exports.delocalizeRoute = exports.localizePathname = exports.getLangFromPathname = exports.getDomainLang = exports.getPathParams = exports.resolveRewrite = exports.matchRoute = void 0;
const utils_1 = require("@obvio/utils");
const helpers_1 = require("./helpers");
const constants_1 = require("../../constants");
const env_1 = require("../../env");
const href_1 = require("../href");
const storage_1 = require("../storage");
var helpers_2 = require("./helpers");
Object.defineProperty(exports, "matchRoute", { enumerable: true, get: function () { return helpers_2.matchRoute; } });
Object.defineProperty(exports, "resolveRewrite", { enumerable: true, get: function () { return helpers_2.resolveRewrite; } });
Object.defineProperty(exports, "getPathParams", { enumerable: true, get: function () { return helpers_2.getPathParams; } });
function getDomainLang(pathname) {
    var _a;
    if (env_1.STAGE === 'production' && pathname) {
        const fromPath = getLangFromPathname(pathname);
        if ((0, utils_1.keys)(constants_1.LOCALE_DOMAINS).includes(fromPath)) {
            return fromPath;
        }
    }
    if (env_1.IS_SERVER) {
        return constants_1.DEFAULT_LANG;
    }
    return env_1.IS_SERVER
        ? constants_1.DEFAULT_LANG
        : ((_a = Object.entries(constants_1.LOCALE_DOMAINS).find(([, domain]) => domain === window.location.hostname)) !== null && _a !== void 0 ? _a : [constants_1.DEFAULT_LANG])[0];
}
exports.getDomainLang = getDomainLang;
function getLangFromPathname(pathname) {
    var _a;
    return ((_a = (0, utils_1.keys)(constants_1.LOCALES).find((lang) => pathname === `/${lang}` ||
        new RegExp(`^/${lang}[/?]`, 'u').test(pathname))) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_LANG);
}
exports.getLangFromPathname = getLangFromPathname;
function localizePathname(pathname, locale) {
    if (locale === constants_1.DEFAULT_LANG || pathname.startsWith('/static/')) {
        return pathname;
    }
    const href = new href_1.Href(pathname);
    href.pathname = `/${locale}${localizeRoute(href.pathname, locale)}`.replace(/\/$/u, '');
    return href.toString();
}
exports.localizePathname = localizePathname;
function delocalizeRoute(route, locale = getLangFromPathname(route)) {
    const currentRoute = route.replace(new RegExp(`^/${locale}(/|$)`, 'u'), '/');
    return (0, helpers_1.localizeRoute)(currentRoute, constants_1.PATHNAME_MAP[locale]);
}
exports.delocalizeRoute = delocalizeRoute;
function localizeRoute(route, locale) {
    return (0, helpers_1.localizeRoute)(route, constants_1.LOCALIZED_ROUTES[locale]);
}
exports.localizeRoute = localizeRoute;
function setLangCookie(lang) {
    (0, storage_1.setCookie)('lang', {
        value: lang,
        ttl: '1y',
    });
}
exports.setLangCookie = setLangCookie;
function switchLang(lang, routerPath, { remember = true } = {}, defaultLang = getDomainLang()) {
    if (!constants_1.LOCALES[lang]) {
        throw new Error(`Locale "${lang}" doesn't exist`);
    }
    if (remember) {
        setLangCookie(lang);
    }
    const { pathname, search } = window.location;
    const path = routerPath !== null && routerPath !== void 0 ? routerPath : pathname;
    const current = getLangFromPathname(path);
    if (lang !== current) {
        window.location.replace(`${current === defaultLang
            ? `/${lang}${path}`
            : path.replace(`/${current}`, lang === defaultLang ? '' : `/${lang}`)}${search}`
            .replace('/?', '?')
            .replace(/\/$/u, '') || '/');
    }
}
exports.switchLang = switchLang;
function inferPreferredLanguage(fallback) {
    var _a, _b, _c;
    if (navigator.languages) {
        const fromList = (_a = navigator.languages
            .find((lang) => (0, utils_1.has)(constants_1.LOCALES, lang.slice(0, 2).toLowerCase()))) === null || _a === void 0 ? void 0 : _a.slice(0, 2);
        if (fromList) {
            return fromList;
        }
    }
    const fromLang = (_c = ((_b = navigator.userLanguage) !== null && _b !== void 0 ? _b : navigator.language)) === null || _c === void 0 ? void 0 : _c.slice(0, 2).toLowerCase();
    return (0, utils_1.has)(constants_1.LOCALES, fromLang) ? fromLang : fallback;
}
exports.inferPreferredLanguage = inferPreferredLanguage;
